module.exports = __webpack_public_path__ + "assets/img/19.5a85d40f.png";